module.exports = __webpack_public_path__ + "static/employees-productivity-f4c14ba70ff9945deaa46949576b1834.svg";